import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";

const StringControl = props => (
	<FormGroup validationState={props.validate(
		props.local, props.prop, props.is_required)}>
		<ControlLabel>
			<FormattedMessage id={props.i18n_key} />
		</ControlLabel>
		<FormControl type="text" name={props.prop}
			value={props.local[props.prop].value || ""}
			onChange={props.handleChange} />
	</FormGroup>
);

StringControl.propTypes = {
	i18n_key: PropTypes.string.isRequired,
	prop: PropTypes.string.isRequired,
	validate: PropTypes.func.isRequired,
	is_required: PropTypes.bool,
	local: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired
};

export default StringControl;
